import { useState } from "react";
import TermsModal from "./TermsModal";

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
const activePrice = (row, peak) => (peak ? row.peak || row.normal : row.normal);

/* ───────── Packages (live from CRM) ───────── */
export function LivePackages({ packages, peakActive, peakLabel, onBook }) {
  const [sel, setSel] = useState({});
  const [terms, setTerms] = useState(null); // terms array shown in modal
  if (!packages || packages.length === 0) return null;

  return (
    <div className="ooty-card-grid">
      {packages.map((pkg) => {
        const rows = pkg.rows || [];
        const current = sel[pkg.id] || rows[0]?.label;
        const row = rows.find((r) => r.label === current) || rows[0];
        const price = row ? activePrice(row, peakActive) : 0;
        return (
          <div className="ooty-card" key={pkg.id}>
            {pkg.image && <img src={pkg.image} alt={pkg.name} className="ooty-image" />}
            <div className="ooty-card-content">
              <h3>{pkg.name}</h3>
              <p className="ooty-price">
                {peakActive && row && row.peak > row.normal && (
                  <span style={{ textDecoration: "line-through", color: "#888", marginRight: 8 }}>{inr(row.normal)}</span>
                )}
                <span style={{ color: peakActive ? "#d97706" : "#2E8B57", fontWeight: "bold" }}>{inr(price)}</span>
                {pkg.unit && <span style={{ color: "#888", fontWeight: 400, fontSize: ".8rem" }}> /{pkg.unit}</span>}
              </p>

              {peakActive && <span className="peak-chip">⚡ {peakLabel || "Peak Season"}</span>}

              {rows.length > 1 && (
                <div className="ooty-duration-select">
                  {rows.map((r) => (
                    <button
                      key={r.label}
                      className={`ooty-duration-btn ${current === r.label ? "active" : ""}`}
                      onClick={() => setSel({ ...sel, [pkg.id]: r.label })}
                    >
                      {r.label}
                    </button>
                  ))}
                </div>
              )}

              {(pkg.features?.length > 0 || pkg.exclusions?.length > 0) && (
                <div className="ooty-details">
                  {pkg.features?.length > 0 && (
                    <div>
                      <strong>✅ Inclusions:</strong>
                      <ul>{pkg.features.map((f, i) => <li key={i}>{f}</li>)}</ul>
                    </div>
                  )}
                  {pkg.exclusions?.length > 0 && (
                    <div>
                      <strong>❌ Exclusions:</strong>
                      <ul>{pkg.exclusions.map((f, i) => <li key={i}>{f}</li>)}</ul>
                    </div>
                  )}
                </div>
              )}

              {pkg.terms?.length > 0 && (
                <button className="ooty-button secondary" onClick={() => setTerms(pkg.terms)}>
                  📜 View Terms
                </button>
              )}

              <button
                className="ooty-button"
                onClick={() => onBook(`${pkg.name} – ${row?.label || ""} (${inr(price)}${pkg.unit ? " " + pkg.unit : ""})`)}
              >
                Book Now
              </button>
            </div>
          </div>
        );
      })}
      {terms && <TermsModal terms={terms} onClose={() => setTerms(null)} />}
    </div>
  );
}

/* ───────── Rooms / Stays (live) ───────── */
export function LiveRooms({ rooms, peakActive, peakLabel, onBook }) {
  if (!rooms || rooms.length === 0) return null;
  return (
    <section className="stays-section" id="rooms">
      <div className="how-head">
        <span className="section-eyebrow">Where you'll stay</span>
        <h2 className="how-title">Rooms &amp; Hill Stays</h2>
        <p className="how-sub">Verified, view-blessed stays across the Nilgiris — live tariffs, updated in real time.</p>
      </div>
      <div className="stays-grid">
        {rooms.map((rm) => {
          const row = (rm.rows || [])[0];
          const price = row ? activePrice(row, peakActive) : 0;
          return (
            <article className="stay-card" key={rm.id}>
              <div className="stay-media">
                {rm.image && <img src={rm.image} alt={rm.name} loading="lazy" />}
                <span className="stay-tag">{peakActive ? `⚡ ${peakLabel || "Peak"}` : (rm.unit || "per night")}</span>
              </div>
              <div className="stay-body">
                <h3>{rm.name}</h3>
                <p className="stay-price">
                  {peakActive && row && row.peak > row.normal && (
                    <span style={{ textDecoration: "line-through", color: "#9aa", marginRight: 6, fontWeight: 400 }}>{inr(row.normal)}</span>
                  )}
                  <b>{inr(price)}</b> <span>/{rm.unit || "night"}</span>
                </p>
                {rm.features?.length > 0 && (
                  <ul className="stay-feats">{rm.features.slice(0, 3).map((f, i) => <li key={i}>{f}</li>)}</ul>
                )}
                <button className="stay-link" onClick={() => onBook(`Stay – ${rm.name} (${inr(price)} /${rm.unit || "night"})`)}>
                  Enquire →
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

/* ───────── Vehicles / Cabs (live) ───────── */
export function LiveVehicles({ vehicles, peakActive, peakLabel, onBook }) {
  if (!vehicles || vehicles.length === 0) return null;
  return (
    <div className="Cab-Contant">
      {vehicles.map((v) => {
        const row = (v.rows || [])[0];
        const price = row ? activePrice(row, peakActive) : 0;
        return (
          <div className="Cab-Card" key={v.id}>
            <span style={{ fontSize: "2rem" }}>🚐</span>
            <h3>{v.name}</h3>
            <p>
              {peakActive && row && row.peak > row.normal && <strike>{inr(row.normal)}</strike>} {inr(price)} onwards
            </p>
            {peakActive && <span className="peak-chip">⚡ {peakLabel || "Peak Season"}</span>}
            {v.features?.length > 0 && <ul>{v.features.map((f, i) => <li key={i}>{f}</li>)}</ul>}
            <button className="Cab-Button" onClick={() => onBook(`Cab – ${v.name} (${inr(price)})`)}>Book Now</button>
          </div>
        );
      })}
    </div>
  );
}
